var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbArrowSeparator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 73,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0l11 35.455L1 72",
    stroke: "#EEE"
  })));
}
export default SvgBreadcrumbArrowSeparator;